import { Request, executeRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  console.log('getDocumentImageRequest data:', data)
  return data
}

const getDocumentImageRequest = (entityIdentificationNumber: string, documentType: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.downloadKycImage,
    method: 'POST',
    config: sitConfig(tokens),
    body: {
      entityIdentificationNumber: entityIdentificationNumber,
      documentType: documentType,
    },
    responseType: 'arraybuffer',
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { getDocumentImageRequest }
